<div class="inbuilt-stat-card">
  <!-- <h3 class="card-title">{{ cardTitle }}</h3> -->
  <div class="loading-indicator" *ngIf="loading">Loading...</div>

  <div class="stats-grid" [style.grid-template-columns]="gridTemplateColumns">
    <div class="stat-column" *ngFor="let column of groupedStatItems">
      <div class="stat-item" *ngFor="let item of column.items">
        <p class="stat-title">{{ item.title }}</p>
        <p class="stat-value">{{ item.formattedValue }}</p>
      </div>
    </div>
  </div>
</div>
